import { defineMessages } from 'react-intl';

const messages = defineMessages({
  storageGW: {
    id: 'PV/IXI',
    defaultMessage: 'IBM Storage Protect for Cloud Google Workspace',
  },
  toolTipM365: {
    id: 'cyXfz6',
    defaultMessage: 'Select the number of users to protect Microsoft 365 data',
  },
  requestQuote: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  configuration: {
    id: '7OW8BT',
    defaultMessage: 'Configuration',
  },
  toolTipGW: {
    id: '9XGrfW',
    defaultMessage:
      'Select the number of users to protect Google Workspace data',
  },
  estimatedMonthy: {
    id: 'wNB/GH',
    defaultMessage: 'Estimated monthly cost',
  },
  withUnlimitedStorageToggleOn: {
    id: '/jfLXz',
    defaultMessage:
      'Your selected configurations will utilize unlimited storage in IBM’s Azure Cloud.',
  },
  storageEntra: {
    id: 'V9IiGr',
    defaultMessage: 'IBM Storage Protect for Cloud Microsoft Entra ID',
  },
  thankyouHeader2: {
    id: 'Em5jmp',
    defaultMessage: 'Cloud Subscriptions',
  },
  storageToggle: {
    id: 'D5nsMo',
    defaultMessage: 'With unlimited storage in IBM’s Azure Cloud',
  },
  toolTipSalesforce: {
    id: '6z35Cj',
    defaultMessage: 'Select the number of users to protect Salesforce data',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  returnToEstimator: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  storageM365: {
    id: 'NoBQDw',
    defaultMessage: 'IBM Storage Protect for Cloud Microsoft 365',
  },
  toolTipEntraId: {
    id: '5C9JBi',
    defaultMessage:
      'Select the number of users to protect Microsoft Entra ID data',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  thankyouHeader: {
    id: 'ckeEXx',
    defaultMessage: 'Thank you for your selections',
  },
  users: {
    id: 'YDMrKK',
    defaultMessage: 'Users',
  },
  toggleTooltipOff: {
    id: '9Gyfl+',
    defaultMessage:
      'Select if you prefer to use unlimited storage in IBM’s Azure Cloud',
  },
  storageSalesforce: {
    id: '27cpzS',
    defaultMessage: 'IBM Storage Protect for Cloud Salesforce',
  },
  mainHeader: {
    id: 'h+Vpg7',
    defaultMessage:
      'Estimate your monthly cost for a Storage Protect for Cloud subscription:',
  },
  subHeader1: {
    id: 'N3CZJx',
    defaultMessage:
      'Slide or enter your user count for a quote estimate. 500+ users may qualify for software volume discount.',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  asteriskPrice: {
    id: '6T5A+C',
    defaultMessage:
      'Estimated prices do not include tax and are for new customers, initial purchase only. Volume discounting available.',
  },
  toolTipD365: {
    id: 'UxEPZX',
    defaultMessage: 'Select the number of users to protect Dynamic 365 data',
  },
  withUnlimitedStorageToggleOff: {
    id: 'c47cfr',
    defaultMessage:
      'Your selected configurations will utilize your own cloud storage.',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  customizedQuote: {
    id: 'zn6MYx',
    defaultMessage: 'Get custom quote',
  },
  pricing: {
    id: '5Wwopw',
    defaultMessage: 'Pricing',
  },
  toggleTooltip: {
    id: 'YJyucw',
    defaultMessage: 'Unselect if you prefer to use your own cloud storage',
  },
  storageDynamics: {
    id: 'eWn1XU',
    defaultMessage: 'IBM Storage Protect for Cloud Dynamics 365',
  },
});

export default messages;
